<template>
  <v-dialog
    v-model="myDialog"
    width="100%"
    transition="dialog-bottom-transition"
    content-class="ma-0 align-self-end max-height-100"
  >
    <v-card :style="cardStyle">
      <div style="width: 100%; height: 100%">
        <div
          class="drag-handle d-flex flex-column align-center justify-center"
          @mousedown="startDrag"
          @touchstart="startDrag"
        >
          <div class="handle-bar mb-1"></div>
        </div>
        <div
          ref="container_filter"
          style="width: 100%; height: calc(100% - 80px); overflow-y: auto"
        >
          <v-col cols="12" class="pt-0 pa-4">
            <!-- ========== ========== Fitler ========== ========== -->
            <v-row no-gutters class="mb-2">
              <span class="text-h6 font-weight-bold">{{
                $t("textFilter")
              }}</span>
            </v-row>
            <v-row no-gutters class="d-flex" style="gap: 12px">
              <v-col
                v-for="(item, index) in listFilter"
                :key="index"
                cols="12"
                class="d-flex align-center"
                @click="handleSelectFilter(item)"
              >
                <v-icon class="mr-2">{{ item.icon }}</v-icon>
                <div>
                  {{ item.dynamic_language ? item.label : $t(item.label) }}
                </div>
                <div
                  class="radio-box"
                  :style="{
                    border:
                      filterBy == item.filterBy &&
                      filterValue == item.filterValue
                        ? '5px solid ' + (site.color || '#000000')
                        : '2px solid #bdbdbd',
                  }"
                ></div>
              </v-col>
            </v-row>

            <v-row no-gutters class="my-6">
              <v-divider></v-divider>
            </v-row>

            <!-- ========== ========== Sort ========== ========== -->
            <v-row no-gutters class="mb-2">
              <span class="text-h6 font-weight-bold">{{
                $t("textSortBy")
              }}</span>
            </v-row>
            <v-row no-gutters class="d-flex" style="gap: 12px">
              <v-col
                v-for="(item, index) in listSort"
                :key="index"
                cols="12"
                class="d-flex align-center"
                :style="{
                  opacity: sortBy == item.sortBy ? 1 : 0.4,
                }"
                @click="handleSelectSort(item)"
              >
                <v-icon class="mr-2">{{ item.icon }}</v-icon>
                <div>
                  {{ $t(item.label) }}
                </div>
                <v-icon class="mr-0 ml-auto">{{
                  item.orderBy == "asc"
                    ? "mdi-sort-ascending"
                    : "mdi-sort-descending"
                }}</v-icon>
              </v-col>
            </v-row>
          </v-col>
        </div>
        <div
          class="d-flex align-center px-3"
          style="width: 100%; height: 56px; gap: 12px"
        >
          <v-btn
            class="flex-grow-1"
            outlined
            dark
            :color="site.color"
            @click="handleClear"
            >{{ $t("clear") }}</v-btn
          >
          <v-btn
            class="flex-grow-1"
            dark
            :color="site.color"
            @click="handleSubmit"
            >{{ $t("confirmDefault") }}</v-btn
          >
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import Axios from "@/config/customer-service";

export default {
  emits: ["onClose", "onSubmit"],
  props: {
    dialog: { default: false },
    forCreatedBy: { default: "admin" },
    useFor: { default: "" },
    warrantyRegistrationId: { default: null },
  },
  components: {},
  data() {
    return {
      myDialog: false,
      height: 50, // ความสูงเริ่มต้น 50vh
      isDragging: false,
      startY: 0,
      startHeight: 50,

      listFilter: [
        {
          icon: "mdi-database-outline",
          label: "filterAll",
          filterBy: "",
          filterValue: "",
          dynamic_language: false,
        },
        {
          icon: "mdi-star-outline",
          label: "filterFavorite",
          filterBy: "is_favorite",
          filterValue: "",
          dynamic_language: false,
        },
        {
          icon: "mdi-bell-badge-outline",
          label: "filterUnread",
          filterBy: "unread",
          filterValue: "",
          dynamic_language: false,
        },
        {
          icon: "mdi-tag-off-outline",
          label: "filterNoType",
          filterBy: "type",
          filterValue: "",
          dynamic_language: false,
        },
      ],
      filterBy: "",
      filterValue: "",
      filterByUse: "",
      filterValueUse: "",

      listSort: [
        {
          icon: "mdi-calendar-outline",
          label: "sortDate",
          sortBy: "created_at",
          orderBy: "desc",
        },
        {
          icon: "mdi-format-title",
          label: "sortTitle",
          sortBy: "title",
          orderBy: "asc",
        },
      ],
      sortBy: "created_at",
      orderBy: "desc",
      sortByUse: "created_at",
      orderByUse: "desc",
    };
  },
  async created() {
    await this.getListType();
    await this.getListStatus();
  },
  beforeDestroy() {
    // ลบ event listeners เพื่อป้องกัน memory leak
    window.removeEventListener("mousemove", this.onDrag);
    window.removeEventListener("mouseup", this.stopDrag);
    window.removeEventListener("touchmove", this.onDrag);
    window.removeEventListener("touchend", this.stopDrag);
  },
  methods: {
    closeDialog() {
      this.$emit("onClose");
    },
    startDrag(e) {
      this.isDragging = true;
      // รองรับทั้ง Touch และ Mouse
      this.startY = e.type.includes("touch") ? e.touches[0].clientY : e.clientY;
      this.startHeight = this.height;

      // เพิ่ม Event Listener ระดับ window เพื่อให้ลากได้ต่อเนื่องแม้เมาส์จะหลุดจากแถบ handle
      window.addEventListener("mousemove", this.onDrag);
      window.addEventListener("mouseup", this.stopDrag);
      window.addEventListener("touchmove", this.onDrag, { passive: false });
      window.addEventListener("touchend", this.stopDrag);

      // ป้องกันการเลือกข้อความขณะลาก
      document.body.style.userSelect = "none";
    },
    onDrag(e) {
      if (!this.isDragging) return;

      // ป้องกันการ Scroll หน้าพื้นหลังขณะลากบน Mobile
      if (e.type === "touchmove") e.preventDefault();

      const currentY = e.type.includes("touch")
        ? e.touches[0].clientY
        : e.clientY;
      const deltaY = this.startY - currentY;
      const deltaVH = (deltaY / window.innerHeight) * 100;

      let newHeight = this.startHeight + deltaVH;

      // ข้อจำกัดความสูง
      if (newHeight > 100) newHeight = 100;
      if (newHeight < 25) newHeight = 25;

      this.height = newHeight;
    },
    stopDrag() {
      if (!this.isDragging) return;
      this.isDragging = false;
      document.body.style.userSelect = "";

      // Snap Logic (ระบบแม่เหล็ก)
      if (this.height > 80) {
        this.height = 100; // ลากขึ้นสูงเกิน 80% ให้เต็มจอ
      } else if (this.height < 35) {
        this.closeDialog(); // ลากลงต่ำกว่า 35% ให้ปิด
      } else {
        this.height = 50; // กลับมาที่จุดเริ่มต้นครึ่งจอ
      }

      window.removeEventListener("mousemove", this.onDrag);
      window.removeEventListener("mouseup", this.stopDrag);
      window.removeEventListener("touchmove", this.onDrag);
      window.removeEventListener("touchend", this.stopDrag);
    },

    // ========== ========== ========== ==========
    async getListType() {
      try {
        const response = await Axios.get(
          `/report-admin/getListReportType?for_created_by=${
            this.forCreatedBy
          }&for_filter=true&use_for=${
            this.warrantyRegistrationId || this.useFor == "warranty"
              ? "warranty"
              : "general"
          }&warranty_registration_id=${this.warrantyRegistrationId || ""}`
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse?.data || [];
          if (this.forCreatedBy == "employee") {
            this.listFilter = this.listFilter.filter(
              (x) => x.filterBy != "type"
            );
          }
          for (let item of data) {
            this.listFilter.push({
              icon: "mdi-tag-outline",
              label: item.label,
              filterBy: "type",
              filterValue: item.value,
              dynamic_language: true,
            });
          }
        }
      } catch (err) {
        console.log("getListType", err);
      }
    },
    async getListStatus() {
      if (this.forCreatedBy == "admin") return;
      try {
        const response = await Axios.get(
          `/report-admin/getListReportStatus?for_filter=true&use_for=${
            this.warrantyRegistrationId || this.useFor == "warranty"
              ? "warranty"
              : "general"
          }&warranty_registration_id=${this.warrantyRegistrationId || ""}`
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse?.data || [];
          for (let item of data) {
            this.listFilter.push({
              icon: "mdi-file-cog-outline",
              label: this.$t("filterReportStatus", {
                report_status_name: item.label,
              }),
              filterBy: "status",
              filterValue: item.value,
              dynamic_language: true,
            });
          }
        }
      } catch (err) {
        console.log("getListType", err);
      }
    },

    handleSelectFilter(param) {
      this.filterBy = param.filterBy;
      this.filterValue = param.filterValue;
    },
    handleSelectSort(param) {
      const sortBy_old = this.sortBy;
      this.sortBy = param.sortBy;
      const model = this.listSort.find((x) => x.sortBy == this.sortBy);
      if (model) {
        let _orderBy = param.orderBy == "asc" ? "desc" : "asc";
        if (this.sortBy != sortBy_old) {
          _orderBy = param.orderBy;
        }
        model.orderBy = _orderBy;
        this.orderBy = _orderBy;
      }
    },
    handleSubmit() {
      this.filterByUse = this.filterBy;
      this.filterValueUse = this.filterValue;
      this.sortByUse = this.sortBy;
      this.orderByUse = this.orderBy;
      let detail = {
        filterBy: this.filterByUse,
        filterValue: this.filterValueUse,
        sortBy: this.sortByUse,
        orderBy: this.orderByUse,
      };
      this.$emit("onSubmit", detail);
    },
    handleClear() {
      this.filterBy = "";
      this.filterValue = "";
      this.sortBy = "created_at";
      this.orderBy = "desc";
      for (let item of this.listSort) {
        if (item.sortBy == this.sortBy) {
          item.orderBy = this.orderBy;
        } else {
          item.orderBy = "asc";
        }
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    cardStyle() {
      return {
        height: `${this.height}vh`,
        maxHeight: "100vh",
        // เมื่อกำลังลาก ให้ปิด transition เพื่อให้การลากลื่นไหลตามมือ
        transition: this.isDragging
          ? "none"
          : "height 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)",
        borderTopLeftRadius: this.height == 100 ? "0px" : "28px",
        borderTopRightRadius: this.height == 100 ? "0px" : "28px",
        overflow: "hidden",
      };
    },
    checkMenuMain() {
      let check = false;
      if (
        this.site?.is_use_float_panel_main &&
        this.site?.float_panel_main?.menu?.length > 0
      ) {
        check = true;
      }
      return check;
    },
    checkMenuExtend() {
      let check = false;
      if (
        this.site?.is_use_float_panel_extend &&
        this.site?.float_panel_extend?.menu?.length > 0
      ) {
        check = true;
      }
      return check;
    },
    menuMain() {
      let list = [];
      if (this.site?.float_panel_main?.menu?.length > 0) {
        list = this.site?.float_panel_main?.menu;
      }
      return list;
    },
    menuExtend() {
      let list = [];
      if (this.site?.float_panel_extend?.menu?.length > 0) {
        list = this.site?.float_panel_extend?.menu;
      }
      return list;
    },
  },
  watch: {
    dialog: {
      handler() {
        this.myDialog = this.dialog;
        if (this.myDialog) {
          this.filterBy = this.filterByUse;
          this.filterValue = this.filterValueUse;
          this.sortBy = this.sortByUse;
          this.orderBy = this.orderByUse;
          for (let item of this.listSort) {
            if (item.sortBy == this.sortBy) {
              item.orderBy = this.orderBy;
            } else {
              item.orderBy = "asc";
            }
          }
          this.$nextTick(() => {
            if (this.$refs.container_filter) {
              this.$refs.container_filter.scrollTop = 0;
            }
          });
        }
      },
    },
    myDialog: {
      handler() {
        if (this.myDialog) {
          this.height = 50;
        } else {
          this.$emit("onClose");
        }
      },
    },
  },
};
</script>

<style>
.max-height-100 {
  max-height: 100% !important;
}
</style>

<style scoped>
.drag-handle {
  width: 100%;
  height: 24px;
  cursor: ns-resize; /* Cursor สำหรับลากขึ้นลงบน Desktop */
  user-select: none;
  background-color: #fff;
}
.handle-bar {
  width: 45px;
  height: 5px;
  background-color: #e0e0e0;
  border-radius: 10px;
}

::v-deep .v-btn__content {
  width: 100%;
  flex-direction: column;
}
.float-panel-btn {
  width: 100px;
  height: 80px !important;
  border-radius: 12px;
  background-color: #ffffff !important;
}
.description-label {
  line-height: 1.3;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.radio-box {
  width: 16px;
  height: 16px;
  margin-right: 0;
  margin-left: auto;
  border-radius: 50%;
  box-sizing: border-box;
}
</style>
